// ExpertCard.tsx - Expert Card Component
// Metronic UI + lucide-react

import { Calendar, Sparkles, User } from 'lucide-react'
import { Expert } from '../../types/expert'

interface ExpertCardProps {
  expert: Expert
  onClick?: () => void
}

export default function ExpertCard({ expert, onClick }: ExpertCardProps) {
  const years = expert.death_year
    ? `${expert.birth_year}-${expert.death_year}`
    : `${expert.birth_year}-gunumuze`

  return (
    <div
      className="card cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onClick}
      style={{
        background: 'var(--card-bg)',
        borderColor: 'var(--border-color)'
      }}
    >
      <div className="card-body p-4">
        {/* Avatar + Name */}
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center"
            style={{ background: 'var(--primary-color)', color: 'white' }}
          >
            <User size={24} />
          </div>
          <div className="flex-1">
            <h3
              className="text-lg font-semibold mb-0"
              style={{ color: 'var(--text-primary)' }}
            >
              {expert.name}
            </h3>
            <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
              <Calendar size={14} />
              <span>{years}</span>
            </div>
          </div>
        </div>

        {/* Category Badge */}
        <div className="mb-3">
          <span
            className="badge badge-primary"
            style={{
              background: 'var(--primary-color)',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          >
            {expert.category_id}
          </span>
        </div>

        {/* Bio Short */}
        {expert.bio_short && (
          <p
            className="text-sm mb-3 line-clamp-2"
            style={{ color: 'var(--text-secondary)' }}
          >
            {expert.bio_short}
          </p>
        )}

        {/* Thinking Style */}
        {expert.thinking_style && (
          <div className="flex items-center gap-2">
            <Sparkles size={14} style={{ color: 'var(--primary-color)' }} />
            <span
              className="text-xs"
              style={{ color: 'var(--text-secondary)' }}
            >
              {expert.thinking_style}
            </span>
          </div>
        )}

        {/* Quality Score */}
        <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--border-color)' }}>
          <div className="flex items-center justify-between">
            <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>
              Kalite Skoru
            </span>
            <span
              className="text-sm font-semibold"
              style={{ color: 'var(--primary-color)' }}
            >
              {expert.quality_baseline}/100
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
